// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ScrollCarouselController from "./scroll_carousel_controller"
application.register("scroll-carousel", ScrollCarouselController)

import HeroCarouselController from "./hero_carousel_controller"
application.register("hero-carousel", HeroCarouselController)

import DropdownActiveController from "./dropdown_active_controller"
application.register("dropdown-active", DropdownActiveController)

import SubmenuController from "./submenu_controller"
application.register("submenu", SubmenuController)

import DropdownScrollController from "./dropdown_scroll_controller"
application.register("dropdown-scroll", DropdownScrollController)

import DropdownManagerController from "./dropdown_manager_controller"
application.register("dropdown-manager", DropdownManagerController)

import IconRotateController from "./icon_rotate_controller"
application.register("icon-rotate", IconRotateController)

import ReadyAwareVideosController from "./ready_aware_videos_controller"
application.register("ready-aware-videos", ReadyAwareVideosController)

import MobileNavController from "./mobile_nav_controller"
application.register("mobile-nav", MobileNavController)

import LoadMoreController from "./load_more_controller"
application.register("load-more", LoadMoreController)

import VideoModalController from "./video_modal_controller"
application.register("video-modal", VideoModalController)

import PdfReaderController from "./pdf_reader_controller"
application.register("pdf-reader", PdfReaderController)

import BarChartController from "./bar_chart_controller"
application.register("bar-chart", BarChartController)
